import { memo, useCallback, useEffect, useState } from 'react'
import './VisitTableColumnRows.scss'
// @ts-expect-error TS7016 -- MIGRATION: not approved, fix when encountered
import { DrugScreenTag, FullTextToolTip, IdVerificationStatusTag, PatientVisitTag } from 'ui_kit_qmd'
import { useDispatch, useSelector } from 'react-redux'
import classNames from 'classnames'
import { EventLocations } from 'lib/segment/constants'
import { generateTableList, generateVisitTableRowStatus } from '../../../utils/VisitsCommon'
import { getVisitInfo } from '../../../store/visits/VisitsActions'
import BookingId from '../../../components/bookingId/BookingId'
import { getTabId, isDrugScreenTagClickable, isIDVerificationClickable, toTimeZone } from '../../../utils/common'
import { getMediaFile } from '../../../store/file-pop-up/FilePopUpThunk'
import { getIDVerification } from '../../../store/id-verification-pop-up/IDVerificationPopUpThunk'
import { getVisitTypeIconProps } from '../../../utils/getVisitTypeIconProps'
import { getVisitTypeLabel } from '../../../utils/getVisitTypeLabel'
import { windowOpenArgs } from 'utils/windowOpenArgs'

export const VisitTableColumnRows = memo(
  ({
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    type,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    Date,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    Service,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    VisitMethod,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    VisitTypeName,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    Patient,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    PatientId,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    Remarks,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    Screening,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    Status,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    VisitNumber,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    VisitId,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    id,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isLast,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    IsNewForPatient,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    IsNewForServiceType,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    isUpcoming,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    timeZone,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    index,
    // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
    setTriggerTabId,
  }) => {
    const [correctTableBodyRowList, setCorrectTableBodyRowList] = useState([])
    const dispatch = useDispatch()
    const tabId = getTabId()

    // @ts-expect-error TS18046 -- MIGRATION: not approved, fix when encountered
    const flags = useSelector((state) => state.flags.flags)

    const onClickBookingId = useCallback(
      // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
      (visitId) => {
        setTriggerTabId(tabId)
        dispatch(getVisitInfo(visitId))
      },
      [dispatch, setTriggerTabId, tabId],
    )

    const onClickPatientName = () => {
      const link = `${window.location.origin}/patientcharts/patient?id=${PatientId}&ref=${EventLocations.visits}`
      window.open(link, ...windowOpenArgs)
    }
    const DateTime = toTimeZone(Date, timeZone).format('MMM DD, YYYY')
    const DayTime = toTimeZone(Date, timeZone).format('h:mma')

    useEffect(() => {
      switch (type) {
        case 'upcomingCollapsed':
          // @ts-expect-error TS2554 -- MIGRATION: not approved, fix when encountered
          const correctUpcomingRow = generateTableList('upcomingCollapsed')?.map((t) => {
            switch (t.name) {
              case 'Booking ID':
                return { ...t, data: { BookingId } }
              case 'Date':
                return {
                  ...t,
                  data: {
                    DateTime,
                    DayTime,
                  },
                }
              case 'Visit':
                return { ...t, data: { VisitMethod, VisitTypeName } }
              case 'Patient':
                return { ...t, data: Patient }
              case 'Tags':
                return {
                  ...t,
                  data: {
                    DrugScreen: Patient.DrugScreen,
                    IdentityVerification: Patient.IdentityVerification,
                  },
                }
              case 'Remarks':
                return { ...t, data: Remarks }
              case 'Screening':
                return { ...t, data: Screening || '--' }
              case 'Status':
                return { ...t, data: generateVisitTableRowStatus(Status) }
              default:
                break
            }
          })

          setCorrectTableBodyRowList(correctUpcomingRow)
          break
        case 'pastCollapsed':
          // @ts-expect-error TS7006 -- MIGRATION: not approved, fix when encountered
          const correctPastRow = generateTableList('pastCollapsed', false, true)?.map((t) => {
            switch (t.name) {
              case 'Booking ID':
                return { ...t, data: { BookingId } }
              case 'Date':
                return {
                  ...t,
                  data: {
                    DateTime,
                    DayTime,
                  },
                }
              case 'Visit':
                return { ...t, data: { VisitMethod, VisitTypeName } }
              case 'Patient':
                return { ...t, data: Patient }
              case 'Tags':
                return {
                  ...t,
                  data: {
                    DrugScreen: Patient.DrugScreen,
                    IdentityVerification: Patient.IdentityVerification,
                  },
                }
              case 'Remarks':
                return { ...t, data: Remarks }
              case 'Status':
                return { ...t, data: generateVisitTableRowStatus(Status) }
              default:
                break
            }
          })
          setCorrectTableBodyRowList(correctPastRow)
          break
        default:
          break
      }
    }, [type, Date, Service, VisitMethod, VisitTypeName, Patient, Remarks, Screening, Status, DateTime, DayTime])

    // @ts-expect-error TS7031 -- MIGRATION: not approved, fix when encountered
    const getTooltip = ({ name, data }) =>
      name === 'Visit' ? getVisitTypeLabel(data?.VisitTypeName, data?.VisitMethod)
      : name === 'Patient' ? `${data?.FirstName} ${data?.LastName}`
      : name === 'Date' ? ''
      : name === 'Booking ID' ? data?.BookingId
      : data

    const getFile = useCallback(() => {
      dispatch(getMediaFile(Patient, tabId))
    }, [Patient])

    const getIDVerificationInfo = useCallback(() => {
      dispatch(getIDVerification(Patient.PatientId, tabId))
    }, [dispatch, tabId, Patient])

    return (
      <div
        className={`visits-page-table-body-row-container ${
          type === 'upcomingCollapsed' ? 'table-upcoming-visits' : 'table-past-visits'
        }`}>
        {correctTableBodyRowList ?
          correctTableBodyRowList.map(
            ({ name, data, additionalContainerStyle, additionalSpanStyle, isWithIcon }, i) => (
              <div
                // eslint-disable-next-line react/no-array-index-key
                key={i}
                className={classNames('visits-page-table-body-item', { tagsItem: name === 'Tags' })}
                style={additionalContainerStyle}
                id={name + id}>
                {isWithIcon && name === 'Visit' ?
                  // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                  <img className='visits-page-table-visit-type-icon' {...getVisitTypeIconProps(data?.VisitMethod)} />
                : null}
                <FullTextToolTip
                  isMultipleLine={name === 'Date'}
                  id={`${name + id}text`}
                  extraStyle={{
                    bottom:
                      isLast && index !== 0 ? 57
                      : index === 0 && isLast ? 0
                      : -15,
                    left:
                      name === 'Visit' ? '220px'
                      : name === 'Status' ? '1000px'
                      : '0px',
                    right: name === 'Patient' ? '0px' : null,
                    marginLeft: name === 'Patient' ? 'auto' : null,
                    marginRight: name === 'Patient' ? 'auto' : null,
                    position: 'absolute',
                    whiteSpace: 'nowrap',
                    zIndex: 9000,
                    pointerEvents: 'none',
                    width: 'max-content',
                  }}
                  fullText={getTooltip({ name, data })}
                  view={
                    <>
                      <span
                        id={`${name + id}text`}
                        style={additionalSpanStyle}
                        className='visits-table-row-label'
                        // @ts-expect-error TS2322 -- MIGRATION: not approved, fix when encountered
                        onClick={name === 'Patient' ? onClickPatientName : null}
                        role='presentation'>
                        <div />
                        {name === 'Booking ID' && (
                          <BookingId {...{ VisitNumber, VisitId }} onClickBookingId={onClickBookingId} />
                        )}
                        {/*
                         // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered */}
                        {name === 'Visit' && getVisitTypeLabel(data?.VisitTypeName, data?.VisitMethod)}
                        {name === 'Patient' && (
                          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                          <span className='visits-table-patient-column'>{`${data?.FirstName} ${data?.LastName}`}</span>
                        )}

                        {name === 'Date' && (
                          <>
                            {/*
                             // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered */}
                            <div style={additionalSpanStyle}>{data.DateTime}</div>
                            {/*
                             // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered */}
                            <div style={additionalSpanStyle}>{data.DayTime}</div>
                          </>
                        )}
                        {name !== 'Booking ID' &&
                          name !== 'Visit' &&
                          name !== 'Tags' &&
                          name !== 'Patient' &&
                          name !== 'Date' &&
                          data}
                      </span>
                      <div className='visits-table-tags-wrapper'>
                        {name === 'Tags' && isUpcoming ?
                          <PatientVisitTag
                            className='visits-list-patient-tag'
                            isNewForPatient={IsNewForPatient}
                            isNewForServiceType={IsNewForServiceType}
                          />
                        : null}
                        {(
                          name === 'Tags' &&
                          flags.id_verification_show_tag_provider &&
                          // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                          data.IdentityVerification?.Status
                        ) ?
                          <IdVerificationStatusTag
                            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                            tagStatus={data.IdentityVerification.Status}
                            onClick={
                              // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                              isIDVerificationClickable(data?.IdentityVerification.Status) ? getIDVerificationInfo : (
                                null
                              )
                            }
                            className='visits-list-id-verification-tag'
                            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                            requestDateTime={data.IdentityVerification.RequestDateTime}
                          />
                        : null}
                        {/*
                         // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered */}
                        {name === 'Tags' && data.DrugScreen ?
                          <DrugScreenTag
                            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                            type={data.DrugScreen.Status}
                            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                            completedDate={data.DrugScreen.CompleteDate}
                            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                            expiredDate={data.DrugScreen.ExpireDate}
                            // @ts-expect-error TS2339 -- MIGRATION: not approved, fix when encountered
                            onClick={isDrugScreenTagClickable(data.DrugScreen.Status) ? getFile : null}
                          />
                        : null}
                        {name === 'Tags' && !data && (!isUpcoming || (!IsNewForPatient && !IsNewForServiceType)) ?
                          '--'
                        : null}
                      </div>
                    </>
                  }
                />
              </div>
            ),
          )
        : null}
      </div>
    )
  },
)
